import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import LoadingScreen from "./LoadingScreen";
import api from "../core/api";

export default function AuthGuard({ children }) {
  const [status, setStatus] = useState("loading");
  const [retryKey, setRetryKey] = useState(0);
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;

    async function checkAuth() {
      if (!localStorage.getItem("token")) {
        if (!cancelled) setStatus("guest");
        return;
      }
      try {
        const { data } = await api.get("/auth/me");
        if (data?.user && data.success !== false) {
          localStorage.setItem("user", JSON.stringify(data.user));
          if (!cancelled) setStatus("authed");
        } else if (!cancelled) setStatus("server-error");
      } catch (err) {
        if (cancelled) return;
        if (!err.response) return setStatus("offline");
        if (err.response.status === 401) return setStatus("guest");
        setStatus("server-error");
      }
    }

    checkAuth();
    return () => {
      cancelled = true;
    };
  }, [retryKey]);

  const retry = () => {
    setStatus("loading");
    setRetryKey((k) => k + 1);
  };

  if (status === "loading") return <LoadingScreen message="در حال بررسی ورود..." />;
  if (status === "offline")
    return (
      <LoadingScreen
        variant="error"
        title="اتصال اینترنت برقرار نیست"
        message="اتصال خود را بررسی کنید و دوباره تلاش کنید."
        onRetry={retry}
      />
    );
  if (status === "server-error")
    return (
      <LoadingScreen
        variant="error"
        title="خطا در ارتباط با سرور"
        message="سرور در دسترس نیست. کمی بعد دوباره تلاش کنید."
        onRetry={retry}
      />
    );
  if (status === "guest")
    return <Navigate to="/login" state={{ from: location }} replace />;

  return children;
}
